import React from 'react';
import LongText from '../Elements/LongText';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import JsxHelper from '../Helpers/JsxHelper';

export default class TpDataImportExcludedItem {
  constructor(item) {
    if (item === undefined) {
      this.TpDataImportExcludedItemId = ''; // '' => Upsert treats it as a create
      this.EntityType = 'TpEvaluatorLink';
      this.Pattern = '';
      this.PatternType = '';
      this.TpInstanceId = '';
      this.ThirdPartyInstanceName = '';
      this.IsActive = true;
      this.Reason = '';
      this.CreatedOnUtc = null;
      this.ModifiedOnUtc = null;
      this.CreatedBy = null;
      this.ModifiedBy = null;
      return;
    }
    this.TpDataImportExcludedItemId = item.tpDataImportExcludedItemId;
    this.EntityType = item.entityType;
    this.Pattern = item.pattern;
    this.PatternType = item.patternType;
    this.TpInstanceId = item.tpInstanceId;
    this.ThirdPartyInstanceName = item.thirdPartyInstanceName;
    this.IsActive = item.isActive === true;
    this.Reason = item.reason;
    this.CreatedOnUtc = item.createdOnUtc;
    this.ModifiedOnUtc = item.modifiedOnUtc;
    this.CreatedBy = item.createdBy;
    this.ModifiedBy = item.modifiedBy;
  }

  static displayedInList = 'Pattern';

  static NameOfTheIdField() {
    return 'TpDataImportExcludedItemId';
  }
  static nameOfTheItemDetailList() {
    return 'TpDataImportExcludedItem';
  }

  static MoneyFields = [];
  static Currency() {
    return '';
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOnUtc', 'ModifiedOnUtc'];
  static BoolFields = ['IsActive'];

  static FieldsToShowInListTable = [
    {
      tabName: 'Main',
      tabLabel: 'Main',
      icon: 'fa-solid fa-filter-circle-xmark',
      data: [
        {
          name: 'TpDataImportExcludedItemId',
          label: 'ID',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        { name: 'EntityType', label: 'Entity Type', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        { name: 'Pattern', label: 'Pattern', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        { name: 'PatternType', label: 'Pattern Type', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        {
          name: 'ThirdPartyInstanceName',
          label: 'TP Instance',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        { name: 'IsActive', label: 'Active', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        { name: 'Reason', label: 'Reason', width: TabListTableCellWidthEnum.TwoLines, className: 'text-left' },
        { name: 'CreatedOnUtc', label: 'Created On', width: TabListTableCellWidthEnum.Single, className: 'text-left' },
        {
          name: 'ModifiedOnUtc',
          label: 'Modified On',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'ID',
        orderById: 'TpDataImportExcludedItemId',
        data: 'TpDataImportExcludedItemId',
        minWidth: 30,
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: 'Entity Type',
        orderById: 'EntityType',
        data: 'EntityType',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Pattern',
        orderById: 'Pattern',
        data: (d) => (
          <LongText
            text={d.Pattern}
            maxLength={60}
          />
        ),
        className: 'text-left',
        minWidth: 60,
      },
      {
        label: 'Pattern Type',
        orderById: 'PatternType',
        data: 'PatternType',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'TP Instance',
        orderById: 'ThirdPartyInstanceName',
        data: 'ThirdPartyInstanceName',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Active',
        orderById: 'IsActive',
        data: (item) => JsxHelper.YesNo(item.IsActive),
        className: 'text-center',
        minWidth: 90,
      },
      {
        label: 'Reason',
        orderById: 'Reason',
        data: (d) => (
          <LongText
            text={d.Reason}
            maxLength={60}
          />
        ),
        className: 'text-left',
        minWidth: 50,
      },
      {
        label: 'Created',
        orderById: 'CreatedOnUtc',
        data: 'CreatedOnUtc',
        className: 'text-center',
        minWidth: 30,
      },
      {
        label: ' ',
        data: TpDataImportExcludedItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => TpDataImportExcludedItem.editFunction(item.TpDataImportExcludedItemId, item),
          },
          {
            iconName: 'fa-solid fa-trash',
            text: 'Delete',
            onClick: () => TpDataImportExcludedItem.deleteFunction(item.TpDataImportExcludedItemId, item),
          },
        ]}
      />
    );
  }

  // Overwritten by the admin page so the row actions can drive panel/delete behaviour.
  static editFunction() {}
  static deleteFunction() {}
}
